import { render } from "./sandTab.vue?vue&type=template&id=1cb8d85b&scoped=true"
import script from "./sandTab.vue?vue&type=script&lang=js"
export * from "./sandTab.vue?vue&type=script&lang=js"

import "./sandTab.vue?vue&type=style&index=0&id=1cb8d85b&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cb8d85b"]])

export default __exports__